import { _stringify, CommonLogger } from '@naturalcycles/js-lib'
import { env } from '@src/environments/environment.js'
import { sentry } from './sentry.util.js'

class SentryLogUtil implements CommonLogger {
  private addBreadCrumb(level: 'error' | 'warning' | 'log', args: unknown[]): void {
    sentry.addBreadcrumb({
      message: _stringify(args),
      level,
    })
  }

  error(...args: unknown[]): void {
    this.addBreadCrumb('error', args)
  }

  warn(...args: unknown[]): void {
    this.addBreadCrumb('warning', args)
  }

  log(...args: unknown[]): void {
    this.addBreadCrumb('log', args)
  }
}

const shouldUseConsole = !env.prod

export const logger: CommonLogger = shouldUseConsole ? console : new SentryLogUtil()
